module.exports = __webpack_public_path__ + "img/SBF2019_Setup_2500x1500.9780c348.jpg";